export interface Point {
  x: number;
  y: number;
}

export interface Body extends Point {
  width: number;
  height: number;
}

export interface Bullet extends Body {
  speed: number;
}

export interface Enemy extends Body {
  speed: number;
  drift: number;
  phase: number;
}

export function overlaps(a: Body, b: Body): boolean {
  return (
    a.x < b.x + b.width &&
    a.x + a.width > b.x &&
    a.y < b.y + b.height &&
    a.y + a.height > b.y
  );
}

export function clamp(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

export function moveToward(current: number, target: number, maxDistance: number): number {
  const distance = target - current;
  if (Math.abs(distance) <= maxDistance) return target;
  return current + Math.sign(distance) * maxDistance;
}

export function difficultyFor(score: number): { enemyInterval: number; enemySpeed: number } {
  return {
    enemyInterval: Math.max(0.34, 0.82 - score * 0.006),
    enemySpeed: Math.min(310, 115 + score * 2.1),
  };
}

